import { setAuthSessionItem, clearAuthSession, sessionUser } from "utils/authSession";
/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
import axios from "axios";
import { appConstants } from "./appConstants";
import { store } from "Store/store";
import { generateTokenID, getCountry, getCurrencyCode, getState } from "./api";
import { MenuItem } from "@mui/material";
import { feedbackBus } from "components/InlineFeedback/InlineFeedback";
import "./../App.scss";
import validator from "validator";
import { CountryStateAction } from "ReduxReducers/countryStateReducer";
export const userTypes = {
  Admin: "admin",
  Customer: "customer",
  Driver: "driver",
};
// export const regexPattern = {
//   onlyAlphabetsWithSpace: "^[a-zA-Z\s]+$",
//   onlyAlphabetsAndNumbersWithSpace: "^[a-zA-Z\d\s]+$",
//   onlyAlphabetsAndNumbersWithoutSpace: "^[a-zA-Z0-9]*$",
//   onlyFloatValues: "^-?[0-9]\d*\.?\d*$",
//   onlyIntValues: "[0-9]*",
//   onlyIntValuesWithSlash: "[0-9\/]*",
//   allCharactersExceptSpace: "^[^ /]+$",
//   onlyWithoutSpace: "^\S*$"
// };

export function exportFileNameDate() {
  try {
    return new Date().toString().substring(0, 24);
  } catch (error) {
    console.log("Catch in exportFileNameDate==", error);
  }
}

export async function getSesstionDataByUserID(userID) {
  return new Promise(async (resolve) => {
    let flag = false;
    try {
      // return;
      await axios
        .post(appConstants.baseURL + "clients/getSesstionDataByUserID", {
          userID,
        })
        .then((res) => {
          let response = res.data;
          if (response.Result_Status) {
            setAuthSessionItem(
              "LOGIN_DETAILS",
              JSON.stringify(res.data.Result_Output)
            );
            setAuthSessionItem(
              "USER_ID",
              JSON.stringify(res.data.Result_Output._id)
            );
            setAuthSessionItem(
              "ROLE_RIGHTS_LOGIN",
              JSON.stringify(response.RoleRights)
            );
            setAuthSessionItem("ROLE", JSON.stringify(response.Role));
            setAuthSessionItem(
              "SELECTED_LOCATION",
              JSON.stringify(response.defaultBusinessLocationID)
            );
            setAuthSessionItem(
              "WIZARD_STATUS_FLAG",
              JSON.stringify(response.wizardStatusFlag)
            );
            setAuthSessionItem(
              "PLAN_DETAILS",
              JSON.stringify(response.planDetails ?? [])
            );
            // sessionStorage.setItem('Employee_Details', JSON.stringify(response.employee[0]));
            flag = true;
            resolve(flag);
          } else resolve(false);
        })
        .catch((error) => {
          console.log("Error in fetching user=", error);
          resolve(flag);
        });
    } catch (error) {
      console.log("Catch in getSesstionDataByID==", error);
      resolve(flag);
    }
  });
}

export async function getScreenRight(screenName) {
  try {
    const storedRights = sessionStorage.getItem("ROLE_RIGHTS_LOGIN");
    if (!storedRights) return "None";

    const roleRights = JSON.parse(storedRights);
    if (!Array.isArray(roleRights)) return "None";

    const screenData = roleRights.find(
      (right) =>
        right.screenName === screenName || right.menuName === screenName
    );
    return screenData?.screenRight || "None";
  } catch (error) {
    console.log("Catch in getScreenRight==", error);
    return "None";
  }
}
export async function blank() {}

export const mapStateToProps = (state) => ({
  loading: state.loading,
});

export async function generateToken(id, dispatch) {
  const requestToken = sessionStorage.getItem("TOKEN");
  if (!requestToken || String(sessionUser()?._id) !== String(id)) return;
  const lastActivity = new Date(store.getState()?.idle?.idleTime).getTime();
  const differnce = Number.isFinite(lastActivity) ? Date.now() - lastActivity : 0;
  const timeDiffernce = differnce / (1000 * 60);
  if (timeDiffernce >= 120) {
    clearAuthSession();
    window.location.href = "/";
  } else {
    await generateTokenID(id, dispatch, (data) => {
      if (!requestToken || sessionStorage.getItem("TOKEN") !== requestToken) return;
      if (data.Result_Status) {
        setAuthSessionItem("TOKEN", data.Result_Output.token);
        window.location.reload();
      } else {
        clearAuthSession();
        window.location.href = "/";
      }
    });
  }
  return;
}

export function generateDataList(
  data,
  keyField,
  valueField,
  preSelectedID = null
) {
  return new Promise((resolve, reject) => {
    if (!data || data.length === 0) {
      reject(new Error("Data is empty"));
    } else {
      const dataList = data.map((item, i) => (
        <MenuItem
          key={i}
          value={item[keyField]}
          disabled={item._id === preSelectedID}
        >
          {item[valueField]}
        </MenuItem>
      ));
      resolve(dataList);
    }
  });
}

export function showResMsg(
  message,
  time,
  status,
  navigate,
  routePath,
  options = {}
) {
  if (!message) return;
  const isSuccess = Boolean(status);
  const type = options?.type || (isSuccess ? "success" : "error");
  const duration = typeof time === "number" ? time : isSuccess ? 2500 : 4500;

  feedbackBus.emit({
    message: typeof message === "string" ? message : String(message),
    type,
    status: isSuccess,
    scope: options?.scope || "global",
    duration,
    routePath,
    timestamp: Date.now(),
  });

  if (routePath && typeof navigate === "function") {
    setTimeout(() => {
      navigate(routePath);
    }, Math.min(duration, 1200));
  }
}

export async function getDownloadFileName(fromDate, toDate) {
  // Function to format dates to "ddMMMyyyy"
  function formatDateString(dateString) {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options).replace(/ /g, "");
  }

  // Get formatted dates
  let formattedFromDate = formatDateString(fromDate);
  let formattedToDate = formatDateString(toDate);

  // Get current seconds
  let currentSeconds = Math.floor(Date.now() / 1000);

  // Construct the final string
  let activityStatement = `Activity Statement ${formattedFromDate}_${formattedToDate}_${currentSeconds}`;
  return activityStatement;
  // console.log(activityStatement);
}
// export function validateFeild(requiredField , values) {
//   return new Promise((resolve, reject) => {
//     if (!requiredField || requiredField.length === 0) {
//       reject(new Error('Data is empty'));
//     } else {
//       const validateResult = requiredField.map(val=>{
//         if(values[val]=== "") return  true
//         else  return false
//       })
//       resolve(validateResult);
//     }
//   });

// }
// const requiredField = ["firstName" ,"lastName" ]
//   const errorList =[setFirstNameErr,setLastNameErrErr ,  ]
//   let arrayData = await  validateFeild(requiredField , values )
//   errorList.forEach( (setError, index) => {
//     setError(arrayData[index])
//   });

export const validatePhoneNumber = (
  value,
  setErrorFunction,
  setPhoneErrorTitle
) => {
  if (value) {
    const phoneNumber = value.toString().trim();

    if (phoneNumber === undefined || phoneNumber === "") {
      setErrorFunction(true);
      setPhoneErrorTitle(`Mobile Number can't be blank`);
      return true;
    } else if (phoneNumber.length < 11) {
      setErrorFunction(true);
      setPhoneErrorTitle(`Enter Valid Phone Number`);
      return true;
    } else {
      setErrorFunction(false);
      setPhoneErrorTitle(``);
      return false;
    }
  } else {
    setErrorFunction(true);
    setPhoneErrorTitle(`Mobile Number can't be blank`);
    return true;
  }
};

export const validateEmailAddress = (
  value,
  setErrorFunction,
  setEmailErrorTitle
) => {
  const emailAddress = value.toString().trim();
  if (!emailAddress) {
    setErrorFunction(true);
    setEmailErrorTitle(`Email Address can't be blank`);
    return true;
  } else if (!validator.isEmail(emailAddress)) {
    setErrorFunction(true);
    setEmailErrorTitle(`Enter valid Email Address`);
    return true;
  } else {
    setErrorFunction(false);
    setEmailErrorTitle(``);
    return false;
  }
};

export const validateCompanyName = (value, setErrorFunction, setErrorTitle) => {
  const companyName = value.toString().trim();

  // Must contain at least one letter, and can include letters, numbers, and dots
  const regex = /^(?=.*[a-zA-Z])[a-zA-Z0-9.]+$/;

  if (!companyName) {
    console.log("companyName", companyName);
    setErrorFunction(true);
    setErrorTitle("Company Name can't be blank");
    return true;
  } else if (!regex.test(companyName)) {
    setErrorFunction(true);
    setErrorTitle(
      "Company Name must contain at least one letter and can include numbers and '.'"
    );
    return true;
  } else {
    setErrorFunction(false);
    setErrorTitle("");
    return false;
  }
};

// export const validateCompanyName = (value, setErrorFunction, setEmailErrorTitle) => {

//   const companyName = value.toString().trim();
//   if (!companyName) {
//     setErrorFunction(true);
//     setEmailErrorTitle(`Company Name can't be blank`);
//     return true;
//   } else if (!validator.isEmail(companyName)) {
//     setErrorFunction(true);
//     setEmailErrorTitle(`Enter valid Company Name`);
//     return true;
//   } else {
//     setErrorFunction(false);
//     setEmailErrorTitle(``);
//     return false;
//   }

// }

export const validateField = (value, setErrorFunction) => {
  if (value === undefined || value === null || value.toString().trim() === "") {
    setErrorFunction(true);
    return true;
  }
  return false;
};

export const nonvalidateField = (value, setErrorFunction) => {
  if (value === undefined || value === null || value.toString().trim() === "") {
    setErrorFunction(false);
    return false;
  }
  return true;
};

export const validateEmailField = (
  email,
  setErrorFunction,
  setemailTitleErr
) => {
  if (email.toString().trim() === "") {
    setErrorFunction(true);
    setemailTitleErr(`Email Address can't be blank`);
    return true;
  } else if (!validator.isEmail(email)) {
    setErrorFunction(true);
    setemailTitleErr("Enter valid Email Address.");
    return true;
  }
  return false;
};

export const validatePhoneNumberField = (
  phoneNumber,
  setMobileNumberErr,
  setpNumberErrMsg
) => {
  if (phoneNumber.toString().trim() === "") {
    setMobileNumberErr(true);
    setpNumberErrMsg("Mobile Number can't be Blank.");
    return true;
  } else if (phoneNumber.toString().length <= 10) {
    setpNumberErrMsg("Mobile Number is invalid.");
    setMobileNumberErr(true);
    return true;
  }
  return false;
};
export const handleStreetAddress = (
  place,
  e,
  outputData,
  stateListRef,
  countryListRef
) => {
  const countryList = countryListRef.current;
  const stateList = stateListRef.current;
  const output = {};
  const addressComponents = place.address_components || [];
  output.streetAddress = place.formatted_address;
  const latlong = place.geometry.location;
  output.locationLatitude = latlong.lat();
  output.locationLongitude = latlong.lng();

  const data = addressComponents.reduce((acc, item) => {
    if (
      item.types &&
      Array.isArray(item.types) &&
      item.types.includes("postal_code") &&
      item.long_name
    ) {
      acc.zipCode = item.long_name;
    } else if (
      item.types &&
      Array.isArray(item.types) &&
      item.types.includes("locality") &&
      item.long_name
    ) {
      acc.city = item.long_name;
    } else if (
      item.types &&
      Array.isArray(item.types) &&
      item.types.includes("country") &&
      item.long_name
    ) {
      acc.countryName = item.long_name; // Store country name temporarily
    } else if (
      item.types &&
      Array.isArray(item.types) &&
      item.types.includes("administrative_area_level_1") &&
      item.long_name
    ) {
      acc.stateName = item.long_name; // Store state name temporarily
    } else if (
      item.types &&
      Array.isArray(item.types) &&
      item.types.includes("route") &&
      item.long_name
    ) {
      acc.streetAddress = item.long_name;
    } else if (
      item.types &&
      Array.isArray(item.types) &&
      item.types.includes("street_number") &&
      item.long_name
    ) {
      acc.streetNumber = item.long_name;
    }
    return acc;
  }, {});

  const isEmptyAddress = place.name === "";

  // Update specific fields in the values object
  if (!isEmptyAddress) {
    if (data.city) {
      output.city = data.city;
    }
    if (data.zipCode) {
      output.zipCode = data.zipCode;
    }
    if (data.streetAddress) {
      if (data.streetNumber !== undefined) {
        output.streetAddress = data.streetNumber + " " + data.streetAddress;
      } else {
        output.streetAddress = data.streetAddress;
      }
    }

    if (data.countryName && Array.isArray(countryList)) {
      const country = countryList.find(
        (item) => item.countryName === data.countryName
      );
      output.countryId = country ? country._id : "";
      output.countryName = data.countryName;
    }
    if (data.stateName && Array.isArray(stateList)) {
      const state = stateList.find((item) => item.stateName === data.stateName);
      output.stateId = state ? state._id : "";
      output.stateName = data.stateName;
    }
  } else {
    // Clear the values if place name is empty
    output.city = "";
    output.zipCode = "";
    output.countryId = "";
    output.stateId = "";
  }
  outputData(output);
};

let cityAndStateRequest = null;

export function getCityAndState() {
  if (store.getState()?.countryState?.check) return Promise.resolve();
  if (cityAndStateRequest) return cityAndStateRequest;

  cityAndStateRequest = (async () => {
    const resData = {};
    await Promise.all([
      getState(async (data) => {
        if (data.Result_Output.length > 0) resData.state = data.Result_Output;
      }),
      getCountry(async (data) => {
        if (data.Result_Output.length > 0) resData.country = data.Result_Output;
      }),
    ]);

    if (resData.state && resData.country) {
      await store.dispatch(CountryStateAction(resData));
    }
  })().finally(() => {
    cityAndStateRequest = null;
  });

  return cityAndStateRequest;
}

export const formatDate = (date) => {
  // Function to format the date to 'DD-MM-YYYY' format
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export async function convertToTitleCase(str) {
  return str.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
    return str.toUpperCase();
  });
}

//Used in For PickData MUI
export async function formatDateWithCurrentTimeForPickDate(date) {
  const currentDate = new Date();
  const selectedDate = new Date(date);
  selectedDate.setHours(currentDate.getHours());
  selectedDate.setMinutes(currentDate.getMinutes());
  selectedDate.setSeconds(currentDate.getSeconds());
  return selectedDate;
}

export const validateABN = (abn) => {
  const abnRegex = /^\s*[1-9](\s*\d){10}\s*$/;
  return abnRegex.test(abn);
};

export const getFileType = (fileType) => {
  let docType = "";
  if (fileType.match("image.*")) {
    docType = "image";
  } else if (fileType.match("pdf.*")) {
    docType = "pdf";
  } else if (
    fileType.match(".doc.*") ||
    fileType.match(".docx.*") ||
    fileType.match(".msword.*")
  ) {
    docType = "doc";
  } else if (fileType.match(".ms-excel.*")) {
    docType = "excel";
  } else if (fileType.match(".csv.*")) {
    docType = "excel";
  } else docType = undefined;

  return docType;
};

export const paymentTermsOptions = [
  "Same Day",
  "7 Days",
  "14 Days",
  "30 Days",
  "14 Days End of Month",
  "30 Days End of Month",
];

//To check if all keys in an object have a value
export function AllKeysHaveValue(obj) {
  return Object.values(obj).every((value) => Boolean(value));
}

export const getCurrencyValue = async () => {
  const currency = await new Promise((resolve, reject) => {
    const session = JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"));
    getCurrencyCode({ businessUserID: session.businessUserID }, resolve);
  });
  if (currency.Result_Status) {
    return currency.Result_Output;
  }
  console.log("currency not found");
  return undefined;
};

export function calculateBaseAmount(totalAmount, taxRate) {
  return totalAmount / (1 + taxRate / 100);
}

export function calculateTaxAmount(totalAmount, taxRate) {
  const baseAmount = calculateBaseAmount(totalAmount, taxRate);
  const taxAmount = totalAmount - baseAmount;
  return Math.round(taxAmount * 100) / 100; // Round to 2 decimal places
}

export function calculatePrice(itemAmount, taxRate, discountAmount) {
  // 1. Apply discount on GST-inclusive price
  console.log(
    "itemAmount, taxRate, discountAmount==",
    itemAmount,
    taxRate,
    discountAmount
  );
  const totalAfterDiscount = itemAmount - discountAmount;

  // 2. Extract GST from GST-inclusive price
  // GST = Total × (taxRate / (100 + taxRate))
  const tax = Math.round(taxRate);
  const taxPercent = tax <= 1 ? tax * 100 : tax;
  const gstAmount = totalAfterDiscount * (taxPercent / (100 + taxPercent));

  // 3. Calculate Ex-Base Amount
  const baseAmount = totalAfterDiscount - gstAmount;

  return {
    itemActualPrice: Number(baseAmount.toFixed(2)),
    taxAmount: Number(gstAmount.toFixed(2)),
    // originalPrice: Number(itemAmount.toFixed(2)),
    // discountAmount: Number(discountAmount.toFixed(2)),
    // totalAfterDiscount: Number(totalAfterDiscount.toFixed(2)),
  };
}

// export function calculatePrice(finalAmount, taxRate, discountAmount) {
//   // Calculate item total price (before discount and tax)
//   let itemTotalPrice = parseFloat((finalAmount / (1 + taxRate / 100)) + discountAmount);

//   // Calculate tax amount
//   let priceAfterDiscount = parseFloat(itemTotalPrice - discountAmount);
//   let taxAmount = parseFloat(taxRate / 100 * priceAfterDiscount);

//   return {
//     itemActualPrice: itemTotalPrice,
//     taxAmount: taxAmount
//   };
// }
export function calculateAmounts(totalAmount, taxRate, discountAmount) {
  const baseAmount = totalAmount / (1 + taxRate / 100);
  const taxAmount = totalAmount - baseAmount;
  return {
    baseAmount: Math.round(baseAmount * 100) / 100,
    taxAmount: Math.round(taxAmount * 100) / 100,
  };
}
